import { ButtonHTMLAttributes, DetailedHTMLProps, forwardRef } from 'react'

interface HoverButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  text: string
}

export const HoverButton = forwardRef<HTMLButtonElement, HoverButtonProps>(function HoverButtonComponent(
  { text, ...rest },
  ref,
) {
  return (
    <button
      ref={ref}
      className='group py-2 px-3 rounded-xl flex items-center gap-2 text-neutral-primary bg-neutral-00 data-[state=open]:bg-button-subtle-hover'
      {...rest}
    >
      <span className='body-medium-emphasis'>{text}</span>
      <span className='hidden group-data-[state=open]:block'>
        <i className='fa-solid fa-caret-up' />
      </span>
      <span className='hidden group-data-[state=closed]:block'>
        <i className='fa-solid fa-caret-down' />
      </span>
    </button>
  )
})
